import { Grid, styled } from "@mui/material";

const BLOG_CAPTION_PREFIX = "BlogCaption";

export const blogCaptionClasses = {
  root: `${BLOG_CAPTION_PREFIX}-root`,
  leftCol: `${BLOG_CAPTION_PREFIX}-leftCol`,
  leftColBrush: `${BLOG_CAPTION_PREFIX}-leftColBrush`,
  rightCol: `${BLOG_CAPTION_PREFIX}-rightCol`,
  brush: `${BLOG_CAPTION_PREFIX}-brush`,
  countryImage: `${BLOG_CAPTION_PREFIX}-countryImage`,
  nextStory: `${BLOG_CAPTION_PREFIX}-nextStory`,
  nextStoryMobile: `${BLOG_CAPTION_PREFIX}-nextStoryMobile`,
  nextStoryText: `${BLOG_CAPTION_PREFIX}-nextStoryText`,
  nextStoryCountry: `${BLOG_CAPTION_PREFIX}-nextStoryCountry`,
  circleCover: `${BLOG_CAPTION_PREFIX}-circleCover`,
  circle: `${BLOG_CAPTION_PREFIX}-circle`,
  sixtySecondsCountry: `${BLOG_CAPTION_PREFIX}-sixtySecondsCountry`,
  smallBrush: `${BLOG_CAPTION_PREFIX}-smallBrush`,
  smallBrushHeading: `${BLOG_CAPTION_PREFIX}-smallBrushHeading`,
  downloadButton: `${BLOG_CAPTION_PREFIX}-downloadButton`,
  metaText: `${BLOG_CAPTION_PREFIX}-metaText`,
};

// Keep the old export for backwards compatibility if needed
export const storyCaptionClasses = blogCaptionClasses;
export const StyledBlogCaption = styled(Grid)(({ theme }) => ({
  [`&.${blogCaptionClasses.root}`]: {
    paddingBottom: "20px",
  },
  [`&.${blogCaptionClasses.nextStoryMobile}`]: {
    display: "block",
    paddingTop: "16px",
    paddingBottom: "8px",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  [`& .${blogCaptionClasses.leftCol}`]: {
    position: "relative",
    zIndex: "99",
    width: "100%",
    [`& span`]: {
      fontSize: "11px",
      color: "#2C4560",
      opacity: "0.5",
    },
    [`& .${blogCaptionClasses.leftColBrush}`]: {
      position: "absolute",
      left: "-170px",
      bottom: "-100px",
    },
    [`& .${blogCaptionClasses.countryImage}`]: {
      position: "relative",
      zIndex: "9",
      width: "100%",
      height: "auto",
    },
  },
  [`& .${blogCaptionClasses.rightCol}`]: {
    display: "none",
    [theme.breakpoints.up("lg")]: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      width: "100%",
      paddingLeft: "56px",
      boxSizing: "border-box",
    },
  },
  [`& .${blogCaptionClasses.brush}`]: {
    position: "absolute",
    top: "-35px",
    left: "-40px",
    zIndex: 91,
  },
  [`& .${blogCaptionClasses.nextStory}`]: {
    display: "grid",
    width: "100%",
    alignItems: "center",
    columnGap: "16px",
    rowGap: "4px",
    paddingTop: "8px",
    paddingBottom: "20px",
    gridTemplateColumns: "minmax(0, 1fr) auto",
    gridTemplateAreas: `"label circle" "title title"`,
    [theme.breakpoints.up("sm")]: {
      gridTemplateAreas: `"label circle" "title circle"`,
      columnGap: "24px",
    },
    [`& .${blogCaptionClasses.nextStoryText}`]: {
      gridArea: "label",
      fontSize: "16px",
      position: "relative",
      zIndex: "2",
      [theme.breakpoints.up("md")]: {
        fontSize: "18px",
      },
    },
    [`& .${blogCaptionClasses.nextStoryCountry}`]: {
      gridArea: "title",
      position: "relative",
      minWidth: 0,
      [`& p`]: {
        fontSize: "18px",
        fontWeight: "900",
        lineHeight: "24px",
        position: "relative",
        zIndex: "2",
        [theme.breakpoints.up("md")]: {
          fontSize: "22px",
          lineHeight: "30px",
        },
      },
      [`& .${blogCaptionClasses.smallBrush}`]: {
        position: "absolute",
        left: "-10px",
        bottom: "0",
        zIndex: 1,
      },
    },
    [`& span`]: {
      fontSize: "14px",
      color: "#fff",
      opacity: "0.7",
      position: "relative",
      zIndex: "2",
    },
  },
  [`& .${blogCaptionClasses.circle}`]: {
    gridArea: "circle",
    width: "88px",
    height: "88px",
    flex: "0 0 auto",
    background: "transparent",
    border: "solid 2px #0F2F4B",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    [theme.breakpoints.up("md")]: {
      width: "123px",
      height: "123px",
    },
    [`& img`]: {
      zIndex: "9",
      filter: "invert(13%) sepia(89%) saturate(750%) hue-rotate(185deg) brightness(16%) contrast(90%)",
    },
  },
  [`& .${blogCaptionClasses.circleCover}`]: {
    width: "129px",
    height: "129px",
    background:
      "transparent linear-gradient(90deg, #162E48 0%, #22395433 100%) 0% 0% no-repeat padding-box",
    borderRadius: "50%",
    position: "absolute",
    top: "-2px",
    left: "-2px",
  },
  [`& .${blogCaptionClasses.sixtySecondsCountry}`]: {
    [`& > div`]: {
      position: "relative",
      [`& h2`]: {
        lineHeight: "79px",
        fontWeight: "900",
        marginBottom: "30px",
        position: "relative",
        zIndex: "2",
      },
    },
    [`& .${blogCaptionClasses.smallBrush}`]: {
      position: "absolute",
      left: "-15px",
      bottom: "7px",
    },
    [`& p`]: {
      fontSize: "18px",
      lineHeight: "30px",
      fontWeight: "900",
      color: "white",
      opacity: "0.7",
      width: "100%",
    },
  },
  [`& .${blogCaptionClasses.downloadButton}`]: {
    fontSize: "16px",
    fontWeight: "normal",
    color: "#011E3F",
    background: "white",
    textTransform: "capitalize",
    borderRadius: "10px",
    height: "48px",
    minWidth: "185px",
  },
  [`& .${blogCaptionClasses.metaText}`]: {
    fontSize: "inherit!important",
    color: "inherit!important",
    opacity: '0.5!important',
  },
}));

// Keep the old export for backwards compatibility if needed
export const StyledStoryCaption = StyledBlogCaption;
